// 3 free characters followed by 5 digits - legacy pattern from 2022 (commit 29d18271)
const DEFAULT_REGISTERED_ID = new RegExp('^.{3}\\d{5}$');

// Belgian CBE/KBO enterprise number: 10 digits starting with 0 or 1,
// either plain (0123456789) or in its visual form (0123.456.789).
const BELGIAN_REGISTERED_ID = new RegExp('^[01](\\d{9}|\\d{3}\\.\\d{3}\\.\\d{3})$');

export function isValidRegisteredId(registeredId?: string, country?: string): boolean {
  if (typeof registeredId !== 'string') {
    return false;
  }

  if (country?.toLowerCase() === 'be') {
    return BELGIAN_REGISTERED_ID.test(registeredId);
  }

  return DEFAULT_REGISTERED_ID.test(registeredId);
}
